import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import LatestBlogPosts from "./sections/LatestBlogPosts";
import FeaturedBlogPosts from "./sections/FeaturedBlogPosts";
import ReadyToTransformYourYard from "./sections/ReadyToTransformYourYard";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <LatestBlogPosts />
      <FeaturedBlogPosts />
      <ReadyToTransformYourYard />
      <Faq />
      <Footer />
    </div>;
}